import './cards.css';
import React  from 'react';

import card1 from './../../img/3GQ67Bwg.jpg';
import card2 from './../../img/Cl_k_q0Q.jpg';
import card3 from './../../img/Ea-mEa8g.gif';
import card4 from './../../img/DD4lhQbw.jpg';
import card5 from './../../img/Snr7kRBw.gif';

const Cards = () => {
  return (
    <div className="cards">
      <img src={card1} alt="" className="card" />
      <img src={card5} alt="" className="card" />
      <img src={card2} alt="" className="card" />
      <img src={card3} alt="" className="card" />
      <img src={card4} alt="" className="card" />
    </div>
  )
};

export default Cards;